export class StageBase {
    /** 编辑器唯一标识 */
    public identity: string;

    constructor(identity: string) {
        this.identity = identity;
    }

    destroy() {}
}
